import React, { useState } from "react";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Layout, Form, Input, DatePicker, Button, Typography, Space } from "antd";

import { SearchAssistanceProgramAPI } from "../api/api";
import { BLUE_DARK } from "../constant/colors";
import ACTIONS from "../store/action";
import { selectIsFetching } from "../store/selector";
import { ApiNames } from "../api/api";
import MedicationOrderForm from "../component/form/MedicationOrderForm";
import { medicationFieldNames, ivMedicationFields, nonIvMedicationFields } from "../constant/newPatientFormFieldNames";

const { Content } = Layout;
const { Title } = Typography;

function NewPatientComponent({ t, history, isFetching, addNewPatientAct }) {
  const [form] = Form.useForm();
  const [programs, setPrograms] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const onAssistanceProgramSearch = async (text) => {
    if (!text) {
      return;
    }
    setIsSearching(true);
    const result = await SearchAssistanceProgramAPI(text);
    const programs = result.data["assistance-programs"];
    setPrograms(programs);
    setIsSearching(false);
  };

  const onSubmit = (values) => {
    const medicationOrderFields = [
      ...Object.keys(medicationFieldNames),
      ...Object.keys(ivMedicationFields),
      ...Object.keys(nonIvMedicationFields)
    ];
    const medicationOrderData = _.pick(values, medicationOrderFields);
    medicationOrderData.startDate = medicationOrderData.nextAdminDate;
    const rxnormDrug = values.rxnormDrug;
    const selectedProgram = programs.find((p) => p.name === values.program);
    const data = { ...values, medicationOrderData, rxnormDrug, selectedProgram };
    addNewPatientAct(data);
  };

  return (
    <Content
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        flexDirection: "column",
        paddingTop: 24
      }}
    >
      <Title level={4} style={{ color: BLUE_DARK }}>
        {t("new_patient.title")}
      </Title>
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 14 }} style={{ width: "70%" }} onFinish={onSubmit}>
        <Form.Item label=" " colon={false} style={{ marginBottom: 0 }}>
          <Title
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              color: BLUE_DARK
            }}
          >
            {t("new_patient.demographics")}
          </Title>
        </Form.Item>

        <Form.Item label={t("new_patient.mrn_label")} style={{ marginBottom: 0 }} colon={false}>
          <Form.Item
            name="mrn"
            rules={[{ required: true, message: t("new_patient.mrn_required") }]}
            style={{ display: "inline-block", width: "calc(50% - 8px)" }}
          >
            <Input placeholder={t("new_patient.mrn_placeholder")} />
          </Form.Item>
          <Form.Item
            name="dateOfBirth"
            label={t("new_patient.date_of_birth_label")}
            rules={[{ required: true, message: t("new_patient.date_of_birth_required") }]}
            colon={false}
            required={false}
            style={{
              display: "inline-block",
              width: "calc(50% - 8px)",
              margin: "0 0 0 8px"
            }}
          >
            <DatePicker format={"MM/DD/YYYY"} style={{ width: "100%" }} />
          </Form.Item>
        </Form.Item>

        <Form.Item colon={false} label={t("new_patient.patient_label")} style={{ marginBottom: 0 }}>
          <Form.Item
            name="firstName"
            rules={[{ required: true, message: t("new_patient.first_name_required") }]}
            style={{ display: "inline-block", width: "calc(33.33% - 8px)" }}
          >
            <Input placeholder={t("new_patient.first_name_placeholder")} />
          </Form.Item>
          <Form.Item
            name="middleName"
            style={{
              display: "inline-block",
              width: "calc(33.33% - 8px)",
              margin: "0 8px"
            }}
          >
            <Input placeholder={t("new_patient.middle_name_placeholder")} />
          </Form.Item>
          <Form.Item
            name="lastName"
            rules={[{ required: true, message: t("new_patient.last_name_required") }]}
            style={{
              display: "inline-block",
              width: "calc(33.33% - 8px)",
              margin: "0 0 0 0"
            }}
          >
            <Input placeholder={t("new_patient.last_name_placeholder")} />
          </Form.Item>
        </Form.Item>

        <MedicationOrderForm
          form={form}
          onAssistanceProgramSearch={onAssistanceProgramSearch}
          isSearching={isSearching}
          programs={programs}
          required={false}
        />

        <Form.Item wrapperCol={{ offset: 16 }} style={{ width: "calc(100% - 8px)" }}>
          <Space>
            <Button htmlType="button" onClick={() => history.goBack()} style={{ width: "100px" }}>
              {t("cancel")}
            </Button>
            <Button type="primary" htmlType="submit" loading={isFetching} style={{ width: "100px" }}>
              {t("submit")}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Content>
  );
}

const mapStateToProps = createStructuredSelector({
  isFetching: selectIsFetching([ApiNames.PharmacyPatientsAdd, ApiNames.PatientPhiInfo])
});

const mapDispatchToProps = (dispatch) => ({
  addNewPatientAct: (patient) => dispatch(ACTIONS.addPatientAction(patient))
});

const NewPatient = connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(NewPatientComponent)));

export { NewPatient };
